import Command from "./Command";

export default Command;
